import styled from 'styled-components';
import breakpoint from '../breakpoints';

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 345px;
  background-color:#cc1d00;
  ${breakpoint('tablet', 'down')} {
    height: 112px;
  }
`
export const Fingerprint = styled.div`
  position: absolute;
  top: 45%;
  right: 6%;
  width: 58vw;
  transform: translate3d(0, -50%, 0);
  img {
    width: 100%;
    display: block;
  }
`
export const FingerprintRight = styled.div`
  position: absolute;
  top: 45%;
  right: -19%;
  width: 58vw;
  transform:translate3d(0, -50%, 0);
  img {
    transform: rotate(180deg);
    width: 100%;
    display: block;
  }
`
export const Image = styled.div`
  display: block;
  position: relative;
  background: #cc1d00;
  padding-top: calc(224/375 * 100%);

  ${breakpoint('tablet', 'up')} {
    padding-top: calc(666/1440 * 100%);
  }

  img {
    width: 100%;
    display: block;
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
  }
`